import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c22554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__title" }, [
  /*#__PURE__*/_createTextVNode(" Стандарт оценки "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" CPITN/BPE ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "abbrs" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "abbr" }, [
      /*#__PURE__*/_createTextVNode(" CPITN (Community Periodontal Index of Treatment Needs) — это "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" индекс, используемый для оценки потребности в "),
      /*#__PURE__*/_createElementVNode("b"),
      /*#__PURE__*/_createTextVNode(" пародонтологическом лечении в обществе. ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "abbr" }, [
      /*#__PURE__*/_createTextVNode(" BPE (Basic Periodontal Examination) – это методика, аналогичная "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" CPITN, используемая в некоторых странах для быстрой оценки "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" состояния пародонта пациента. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "scoring" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "scoring__title" }, "Скоринг"),
    /*#__PURE__*/_createElementVNode("ul", { class: "scoring__list" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "scoring__list-item" }, [
        /*#__PURE__*/_createTextVNode(" Зубной ряд делится на 6 секстантов и фиксируется наивысший "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" балл по каждому секстанту ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "scoring__list-item" }, [
        /*#__PURE__*/_createTextVNode(" Обследуются все зубы в каждом секстанте (за исключением "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" третьих моляров, если первый и/или второй моляр не "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" отсутствует) ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "scoring__list-item" }, " Секстант должен содержать не менее 2 зубов для обследования. "),
      /*#__PURE__*/_createElementVNode("li", { class: "scoring__list-item" }, [
        /*#__PURE__*/_createTextVNode(" Зондом следует «пройтись» по зубам каждого секстанта. Перед "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" переходом к следующему секстанту необходимо проверить все "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" участки, чтобы убедиться в том, что зафиксирован наивысший "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" балл в секстанте. Если в секстанте обнаружен код 4, "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" продолжайте исследовать все участки секстанта. Это поможет "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" получить более полное представление о состоянии пародонта и "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" позволит не пропустить случаи с фуркацией. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "grades" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "0"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, [
        /*#__PURE__*/_createTextVNode(" Глубина при зондировании меньше 3,5мм, нет "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" камня/нависающих краев реставраций, "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" кровоточивости ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "1"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, [
        /*#__PURE__*/_createTextVNode(" Глубина при зондировании меньше 3,5мм, нет "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" камня/нависающих краев реставраций, есть "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" кровоточивость ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "2"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, [
        /*#__PURE__*/_createTextVNode(" Глубина при зондировании меньше 3,5мм, есть "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" над/поддесневой камень/нависающие края "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" реставраций ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "3"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, "Глубина при зондировании 3,5-5,5 мм")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "4"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, " Глубина при зондировании больше 5,5 мм ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "*"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, "Вовлечение фуркации")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grades__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grades__square" }, "X"),
      /*#__PURE__*/_createElementVNode("p", { class: "grades__paragraph" }, [
        /*#__PURE__*/_createTextVNode(" В секстанте присутствует только один зуб или нет ни "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" одного зуба (третьи моляры исключаются, кроме тех "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" случаев, когда они находятся на месте вторых моляров) ")
      ])
    ])
  ])
], -1))


import IconTemplate from '@/apps/components/IconTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isModalVisible: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: __props.isModalVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isModalVisible) ? (isModalVisible).value = $event : null)),
    "show-close": false,
    width: "538"
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(IconTemplate, {
          class: "modal__header-icon",
          height: "25",
          name: "close",
          width: "25",
          onClick: close
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})